import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';

import classNames from 'classnames';
import compose from 'lodash/fp/compose';
import Button from 'jbc-front/components/Button';
import { Pulldown } from 'jbc-front/components/icons';
// import Cookies from 'js-cookie';

import {
  EMPLOYEE_INVITATIONS_LIST,
  EMPLOYEE_NEW,
  INSERT_BATCH_CSV,
  UPDATE_BATCH_CSV,
  EMPLOYEE_CSV_JOB_STATUS,
  LMS_EMPLOYEE_IMPORT_JOB
} from 'src/constants/EndpointUrls';
import SearchDetector from 'src/components/SearchDetector';
import DetailSearchForm from 'src/components/DetailSearchForm';
import SearchFormPaginator from 'src/components/SearchFormPaginator';
import { REDUCER_NAME, fetchEmployees } from 'src/reducers/employees/employees';
import {
  takeEmployeesSearchQueries,
  takeEmployeesSearchQueriesFromLocation,
  takeEmployeesResetFormQueries,
  FORM_NAME_EMPLOYEES_SEARCH
} from 'src/reducers/searchForm';
import FilterEnrollmentStatusBtnList from 'src/features/Employees/components/EnrollmentStatusBtnList';
import { getSelectOptions, setOptions } from 'src/reducers/selectOptions';
import { isFreePlan } from 'src/reducers/clients/currentClient';
import LoadingView from 'src/components/LoadingView';
import { INITIAL_POLLING_INTERVAL, MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import { withTranslation } from 'react-i18next';

import EmployeeTable from './containers/EmployeeTable';
import DownloadCsv from './containers/DownloadCsvContainer';
import NotifyJob from './components/NotifyJob';
import NotifyLmsJob from './components/NotifyLmsJob';
import Balloon from './components/Balloon';
import styles from './EmployeeList.scss';
import { getIsLoading } from '../../reducers/common/listReducer';
import NotifyCsvError from './components/NotifyCsvError';

// const syncsWithLms = () => Cookies.get('using_jbc_lms') === 'true';

class EmployeeList extends React.Component {
  constructor(props) {
    super(props);
    // anyJobRunning: CSVアップロード
    // anyApiRunning: APIで労務と連携
    const { anyJobRunning, notNotifiedJob, anyApiRunning, notNotifiedLmsJob } = this.props;
    this.state = {
      isImportModalOpen: false,
      anyJobRunning,
      anyApiRunning,
      notNotifiedJob,
      notNotifiedLmsJob,
      isEmployeeCoordinationBaloonOpen: false,
      isEmployeeAddBaloonOpen: false
    };
  }

  getLastCsvJobStatus = () => {
    axios
      .get(`${EMPLOYEE_CSV_JOB_STATUS}`, { params: { job_id: _.get(this.state.notNotifiedJob, 'id') } })
      .then(response => {
        // 実行終わりのみアップデートする。
        const job = response.data.payload.job;
        if (job.status === 'success' || job.status === 'failed') {
          this.setState({ anyJobRunning: false, notNotifiedJob: job });
        }
      })
      .catch(error => console.log('error', error));
  };

  getLastLmsJobStatus = () => {
    axios
      .get(`${LMS_EMPLOYEE_IMPORT_JOB}`, { params: { job_id: _.get(this.state.notNotifiedLmsJob, 'id') } })
      .then(response => {
        const job = response.data.payload.job;
        if (job.status === 'success' || job.status === 'failed') {
          this.setState({ anyApiRunning: false, notNotifiedLmsJob: job });
        }
      })
      .catch(error => console.log('error', error));
  };

  pollGetLastCsvJobStatus = interval => {
    let newInterval = interval;
    if (this.state.anyJobRunning) {
      this.getLastCsvJobStatus();
      if (newInterval < MAX_POLLING_INTERVAL) {
        newInterval *= 2;
      }
    }
    setTimeout(this.pollGetLastCsvJobStatus, newInterval, newInterval);
  };

  pollGetLastLmsJobStatus = interval => {
    let newInterval = interval;
    if (this.state.anyApiRunning) {
      this.getLastLmsJobStatus();
      if (newInterval < MAX_POLLING_INTERVAL) {
        newInterval *= 2;
      }
    }
    setTimeout(this.pollGetLastLmsJobStatus, newInterval, newInterval);
  };

  componentDidMount() {
    this.pollGetLastCsvJobStatus(INITIAL_POLLING_INTERVAL);
    this.pollGetLastLmsJobStatus(INITIAL_POLLING_INTERVAL);
  }

  render() {
    const {
      initialValues: formValues,
      location,
      resetValues,
      dispatch,
      planType,
      isListLoading,
      jobs,
      client,
      clientBranch,
      csvExportError
    } = this.props;
    const { anyJobRunning, notNotifiedJob, anyApiRunning, notNotifiedLmsJob } = this.state;

    dispatch(
      setOptions({
        client,
        client_branch: clientBranch
      })
    );
    const freePlan = isFreePlan(planType);
    return (
      <div>
        <SearchDetector
          location={location}
          didMountDetectingJudger={() => true}
          willReceivePropsDetectingJudger={(prevProps, nextProps) => nextProps.location !== prevProps.location}
          onDetect={() => {
            dispatch(fetchEmployees(takeEmployeesSearchQueries(formValues)));
          }}
        />
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.Employees.EmployeeList.employee_list')}</h1>
        </div>
        {notNotifiedJob && <NotifyJob job={notNotifiedJob} />}
        {notNotifiedLmsJob && <NotifyLmsJob job={notNotifiedLmsJob} />}
        {csvExportError.length > 0 && <NotifyCsvError errors={csvExportError} />}
        <div className="l-contents-wrap">
          <div className="l-wrap-xl">
            <div className={styles.buttonArea}>
              <div className={styles.buttonDl}>
                <DownloadCsv downloadEmployeeCsvJobInfo={jobs.downloadEmployeeCsvJobInfo} />
              </div>
              {/*
              <div className={styles.button}>
                <Button
                  onClick={() =>
                    this.setState({
                      isEmployeeCoordinationBaloonOpen: !this.state.isEmployeeCoordinationBaloonOpen,
                      isEmployeeAddBaloonOpen: false
                    })
                  }
                  disabled={freePlan}
                  disabledReason={freePlan ? <FreePlanRestriction /> : null}
                  className="ignore-react-onclickoutside"
                  icon={<Link size={17} />}
                  widthAuto
                >
                  {this.props.t('features.Employees.EmployeeList.link')}
                </Button>
                {this.state.isEmployeeCoordinationBaloonOpen && (
                  <Balloon hide={() => this.setState({ isEmployeeCoordinationBaloonOpen: false })}>
                    <ul className={styles.links} style={{ cursor: 'pointer' }}>
                      <li
                        role="presentation"
                        onClick={e => {
                          e.stopPropagation();
                          this.setState({
                            isImportModalOpen: true,
                            isEmployeeCoordinationBaloonOpen: true
                          });
                        }}
                      >
                        <span>
                          <Pulldown size={8} />{this.props.t('features.Employees.EmployeeList.obtained_from_JOBCAN_Labor_Management')}
                        </span>
                      </li>
                      <li>
                        <a
                          href="https://jobcan-payroll.zendesk.com/hc/ja/articles/360002077414#Contents2"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <Pulldown size={8} />{this.props.t('features.Employees.EmployeeList.check_link_items')}
                        </a>
                      </li>
                      <li>
                        <a href={CHOOSE_COORDINATION_EMPLOYEE}>
                          <Pulldown size={8} />{this.props.t('features.Employees.EmployeeList.employee_labor_link_setting')}
                        </a>
                      </li>
                    </ul>
                  </Balloon>
                )}

                {syncsWithLms() ? (
                  <ImportFromRoumuModal
                    isOpen={this.state.isImportModalOpen}
                    hideModal={() =>
                      this.setState({ isImportModalOpen: false, isEmployeeCoordinationBaloonOpen: true })
                    }
                    onSubmit={() => axios.post(JBC_LMS_EMPLOYEES_IMPORT)}
                  />
                ) : (
                  <UnsyncModal
                    isOpen={this.state.isImportModalOpen}
                    hideModal={() =>
                      this.setState({ isImportModalOpen: false, isEmployeeCoordinationBaloonOpen: true })
                    }
                  />
                )}
              </div>
              */}
              <div className={styles.button}>
                <Button href={EMPLOYEE_INVITATIONS_LIST} as="a" primary widthAuto>
                  {this.props.t('features.Employees.EmployeeList.invite_employee')}
                </Button>
              </div>
              <div className={styles.button}>
                <Button
                  primary
                  widthAuto
                  className="ignore-react-onclickoutside"
                  onClick={() =>
                    this.setState({
                      isEmployeeAddBaloonOpen: !this.state.isEmployeeAddBaloonOpen,
                      isEmployeeCoordinationBaloonOpen: false
                    })
                  }
                  disabled={anyJobRunning || anyApiRunning}
                >
                  {this.props.t('features.Employees.EmployeeList.employee_registration')}
                </Button>
                {this.state.isEmployeeAddBaloonOpen &&
                  !anyApiRunning &&
                  !anyJobRunning && (
                    <Balloon hide={() => this.setState({ isEmployeeAddBaloonOpen: false })}>
                      <ul className={styles.links}>
                        <li>
                          <a href={EMPLOYEE_NEW}>
                            <Pulldown size={8} />
                            {this.props.t('features.Employees.EmployeeList.Register_manual_input')}
                          </a>
                        </li>
                        {!freePlan && (
                          <li>
                            <a href={INSERT_BATCH_CSV}>
                              <Pulldown size={8} />
                              {this.props.t('features.Employees.EmployeeList.Register_CSV_import')}
                            </a>
                          </li>
                        )}
                        {!freePlan && (
                          <li>
                            <a href={UPDATE_BATCH_CSV}>
                              <Pulldown size={8} />
                              {this.props.t('features.Employees.EmployeeList.update_CSV_import')}
                            </a>
                          </li>
                        )}
                      </ul>
                    </Balloon>
                  )}
              </div>
            </div>
            <DetailSearchForm
              menuRender={() => <FilterEnrollmentStatusBtnList />}
              containsOtherSearch={false}
              formName={FORM_NAME_EMPLOYEES_SEARCH}
              resetValues={resetValues}
            />
          </div>
          <LoadingView isLoading={isListLoading}>
            <div className={classNames('l-wrap-xl', styles.list)}>
              <EmployeeTable />
              <SearchFormPaginator formName={FORM_NAME_EMPLOYEES_SEARCH} reducerName={REDUCER_NAME} />
            </div>
          </LoadingView>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  initialValues: {
    ...takeEmployeesSearchQueriesFromLocation(state.router.location, true),
    ...getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state)
  },
  resetValues: takeEmployeesResetFormQueries(state, true),
  location: state.router.location,
  anyJobRunning: getSelectOptions(state, 'anyJobRunning'),
  anyApiRunning: getSelectOptions(state, 'anyApiRunning'),
  planType: _.get(state, 'currentClient.item.data.planType'),
  isListLoading: getIsLoading(REDUCER_NAME, state),
  csvExportError: _.get(state, 'employeesAsync.list.errors')
});

export default withTranslation('translation')(
  compose(
    connect(mapStateToProps),
    reduxForm({
      form: FORM_NAME_EMPLOYEES_SEARCH,
      enableReinitialize: true
    })
  )(EmployeeList)
);
